<template>
  <div class="layout__padding-clear">
    <div class="layout__container">
      <registration-title
        :account-type="account_type"
      />

      <div class="layout__padding__top-25px">

        <customer-details
          v-if="isActive('customer-details')"
          :account-type="account_type"
          :payment-method="payment_method"
          :is-loading="isLoading"
          :final-form="finalForm"
          @back-button-pressed="onBackButtonPressed"
          @step-passed="onStepPassed"
        />

        <company-details
          v-if="isActive('company-details')"
          :is-loading="isLoading"
          :final-form="finalForm"
          @step-passed="onStepPassed"
        />

        <billing-details
          v-if="isActive('billing-details')"
          :final-form="finalForm"
          :is-loading="isLoading"
          @step-passed="onStepPassed"
        />

        <steps
          :current-step="currentStepNumber"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="createCreditRequestSent"
      :before-close="beforeClose"
      append-to-body
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h2 class="text__colour-teal layout__margin__bottom-20">
          Thank you
        </h2>

        <div>
          <p class="layout__margin__bottom-20">
            Your request has gone to our accounts team<br>
            to finalise which could take up to 48 hours.
          </p>
          <p class="layout__margin__bottom-20">
            If we need further information we'll be in touch,<br>
            otherwise you'll receive an email <br>
            once your account is ready to use.
          </p>
          <p class="layout__margin__bottom-20">
            Subject to standard credit checks, you'll have the option <br>
            of paying via monthly invoices or <br>
            via a credit or debit card at checkout.
          </p>
          <h3 class="layout__margin__bottom-20 text__colour-teal">
            In a hurry?
          </h3>
          <p class="layout__margin__bottom-20">
            Speak to our Customer Service team to order now
          </p>
          <p class="layout__margin__bottom-20">
            t: {{ supportPhone }}<br>
            e: {{ supportEmail }}
          </p>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="createPAYGRequestSent"
      :before-close="beforeClose"
      append-to-body
      width="500px"
    >
      <div class="layout__position-center text__align-center">
        <h2 class="text__colour-teal layout__margin__bottom-20">
          Thank you
        </h2>

        <div>
          <p class="layout__margin__bottom-20">
            Your request has gone to our accounts team<br>
            to finalise which could take up to 48 hours.
          </p>
          <p class="layout__margin__bottom-20">
            If we need further information we'll be in touch,<br>
            otherwise you'll receive an email <br>
            once your account is ready to use.
          </p>
          <p class="layout__margin__bottom-20">
            Subject to standard credit checks, you'll have the option <br>
            of paying via monthly invoices or <br>
            via a credit or debit card at checkout.
          </p>
          <h3 class="layout__margin__bottom-20 text__colour-teal">
            In a hurry?
          </h3>
          <p class="layout__margin__bottom-20">
            Speak to our Customer Service team to order now
          </p>
          <p class="layout__margin__bottom-20">
            t: {{ supportPhone }}<br>
            e: {{ supportEmail }}
          </p>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showSuccessPopup"
      :before-close="beforeClose"
      append-to-body
      width="700px"
    >
      <div class="layout__position-center text__align-center">
        <h2 class="text__colour-teal layout__margin__bottom-20">
          Thank you
        </h2>

        <div>
          <p class="layout__margin__bottom-20 text__break-word">
            <template v-if="finalForm.is_account_payment_requested">
              You are now registered and can order using card at check out, in the meantime we will process your application for a credit account which will take up to 48 hours. To browse our products click
            </template>
            <template v-else>
              You are now registered, to browse our products click
            </template>
            <a
              class="link__colour-teal"
              href="#"
              @click.prevent="goToProducts"
            >
              here
            </a>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Axios from 'axios';
import { Loading } from 'element-ui';
import { axios } from '@/mixins/Axios.js';
import VueRecaptcha from 'vue-recaptcha';
import RegistrationTitle from './registration/RegistrationTitle';
import CustomerDetails from './registration/CustomerDetails';
import CompanyDetails from './registration/CompanyDetails';
import BillingDetails from './registration/BillingDetails';
import Steps from './registration/Steps';
import Router from '../router';

export default {
  name: 'creditApplication',

  props: ['account_type', 'payment_method'],

  components: {
    BillingDetails,
    CompanyDetails,
    CustomerDetails,
    RegistrationTitle,
    VueRecaptcha,
    Steps,
  },

  mixins: [axios],

  computed: {
    title() {
      return this.account_type === 'ACCOUNT' ? 'Credit' : 'Pay As You Go';
    },

    payment_method_display() {
      return this.payment_method === 'PAYGEMAILINVOICE' ? 'PAYG email invoice' : 'Monthly email invoice';
    },

    currentStepNumber() {
      switch (this.currentStep) {
        case 'customer-details':
          return 0;
        case 'company-details':
          return 1;
        case 'billing-details':
          return 2;

        default:
          return 0;
      }
    },
  },

  data() {
    return {
      processing: false,
      createCreditAccount: true,
      createCreditRequestSent: false,
      createPAYGRequestSent: false,
      recaptchaNotComplete: true,
      showRecaptcha: true,
      showSuccessPopup: false,
      supportEmail: 'client.support@ravensworth.co.uk',
      supportPhone: '0191 917 9331',

      currentStep: 'customer-details',

      finalForm: {},

      isLoading: false,
    };
  },

  created() {
    this.resetForm();
  },

  mounted() {
    if (`${process.env.VUE_APP_ENVIRONMENT}` === 'dev' || `${process.env.VUE_APP_ENVIRONMENT}` === 'qa') {
      this.showRecaptcha = false;
      this.recaptchaNotComplete = false;
    }
  },

  methods: {
    isActive(currentStep) {
      return this.currentStep === currentStep;
    },

    beforeClose(done) {
      this.resetForm();
      this.$emit('closeAccount');
      this.$emit('closePAYG');

      done();
    },

    resetForm() {
      this.finalForm = {};

      this.currentStep = '';

      this.$nextTick(() => {
        this.currentStep = 'customer-details';
      });
    },

    resetFormFields() {
      this.accountForm.company_name = '';
      this.accountForm.branch_name = '';
      this.accountForm.brand_name = '';
      this.accountForm.branch_address1 = '';
      this.accountForm.branch_address2 = '';
      this.accountForm.branch_address3 = '';
      this.accountForm.branch_town = '';
      this.accountForm.branch_county = '';
      this.accountForm.branch_postcode = '';
      this.accountForm.marketingEmailsConsent = false;
      this.accountForm.main_contact_firstname = '';
      this.accountForm.main_contact_surname = '';
      this.accountForm.main_contact_telephone = '';
      this.accountForm.main_contact_email = '';
      this.accountForm.accounts_contact_name = '';
      this.accountForm.accounts_contact_telephone = '';
      this.accountForm.accounts_contact_email = '';
      this.accountForm.billing_address1 = '';
      this.accountForm.billing_address2 = '';
      this.accountForm.billing_address3 = '';
      this.accountForm.billing_town = '';
      this.accountForm.billing_county = '';
      this.accountForm.billing_postcode = '';
      this.accountForm.email = '';
      //this.accountForm.password = '';
    },

    async saveUser(finishRegistration = false) {
      this.isLoading = true;

      let loadingInstance = Loading.service({
        fullscreen: true,
      });

      const updatedValues = {
        'abpUserId': null, // int64 populated by backend
        'tenantId': null,  // int populated by backend
        'partnerRef': '',  // propulated by backend
        'companyName': this.finalForm.company_name,
        'brandName': this.finalForm.brand_name,
        'branchName': this.finalForm.branch_name,
        'companyRegistrationNumber': this.finalForm.is_account_payment_requested ? this.finalForm.company_registration_number : null,
        'branchTelephone': this.finalForm.telephone,
        'branchEmail': this.finalForm.email,
        'branchAddressLine1': this.finalForm.branch_address1,
        'branchAddressLine2': this.finalForm.branch_address2,
        'branchAddressLine3': this.finalForm.branch_address3,
        'branchTown': this.finalForm.branch_town,
        'branchCounty': this.finalForm.branch_county,
        'branchPostcode': this.finalForm.branch_postcode,
        'mainContactFirstName': this.finalForm.main_contact_firstname || this.finalForm.firstName,
        'mainContactLastName': this.finalForm.main_contact_surname || this.finalForm.surname,
        'mainContactTelephone': this.finalForm.main_contact_telephone || this.finalForm.telephone,
        'mainContactEmail': this.finalForm.main_contact_email,
        'accountsContactName': this.finalForm.accounts_contact_name,
        'accountsContactTelephone': this.finalForm.accounts_contact_telephone,
        'accountsEmail': this.finalForm.accounts_contact_email,
        'billingAddressLine1': this.finalForm.billing_address1,
        'billingAddressLine2': this.finalForm.billing_address2,
        'billingAddressLine3': this.finalForm.billing_address3,
        'billingTown': this.finalForm.billing_town,
        'billingCounty': this.finalForm.billing_county,
        'billingPostcode': this.finalForm.billing_postcode,
        'marketingEmailsConsent': this.finalForm.marketingEmailsConsent,
        'RegistrantUserEmail': this.finalForm.email,
        'accountType': 'PAYG', // Expected values:  PAYG or ACCOUNT
        'paymentMethod': 'PAYGEMAILINVOICE', // Expected values: PAYGEMAILINVOICE or MONTHLYEMAILINVOICE
        'isAccountPaymentRequested': this.finalForm.is_account_payment_requested,
      };

      const endpoint = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/SubmitAccountApplication`;

      try {
        await Axios.post(endpoint, updatedValues, this.returnHeaderUsingToken());

        this.$nextTick(() => {
          loadingInstance.close();
        });

        if (! finishRegistration) {
          this.currentStep = 'company-details';

          this.isLoading = false;

          return;
        }

        this.$emit('closeAccount');
        this.$emit('closePAYG');

        this.isLoading = false;

        this.showSuccessPopup = true;
      } catch (error) {
        event.stopPropagation();

        this.$nextTick(() => {
          loadingInstance.close();
        });

        this.isLoading = false;
      }
    },

    onBackButtonPressed() {
      this.resetForm();
      this.$emit('closeAccount');
      this.$emit('closePAYG');

      document.getElementById('openLoginClosable').click();

      this.$nextTick(() => {
        global.vm.$children[0].$refs.loginClosable.activeForm = 'register';
      });
    },

    async onStepPassed(data) {
      this.isLoading = true;

      this.finalForm = {
        ...this.finalForm,
        ...data.userData,
      };

      if (data.saveUser) {
        await this.saveUser(data.finishRegistration);
      }

      if (data.nextStep) {
        this.currentStep = data.nextStep;
      }

      this.isLoading = false;
    },

    goToProducts() {
      this.showSuccessPopup = false;

      if (this.$router.currentRoute.name !== '/products/print') {
        Router.push({
          name: '/products/print',
        });
      }
    },
  },
};
</script>
